import React, { useEffect, useContext, useState, useRef } from 'react';
import { useSearchParams } from "react-router-dom";
import { NavLink } from 'react-router-dom';
import AppContext from '../../AppContext';


const classNames = (...classes) => {
  return classes.filter(Boolean).join(' ')
}

const PLAYERS = [
  {name:'Matthew Able (NC State)', value:'Matthew Able', team:'NC State'},
  {name:'Darius Acuff Jr. (Arkansas)', value:'Darius Acuff Jr.', team:'Arkansas'},
  {name:'Amari Allen (Alabama)', value:'Amari Allen', team:'Alabama'},
  {name:'Nathaniel Ament (Tennessee)', value:'Nathaniel Ament', team:'Tennessee'},
  {name:'Christian Anderson (Texas Tech)', value:'Christian Anderson', team:'Texas Tech'},
  {name:'Tobe Awaka (Arizona)', value:'Tobe Awaka', team:'Arizona'},
  {name:'Flory Bidunga (Kansas)', value:'Flory Bidunga', team:'Kansas'},
  {name:'Tyler Bilodeau (UCLA)', value:'Tyler Bilodeau', team:'UCLA'},
  {name:'John Blackwell (Wisconsin)', value:'John Blackwell', team:'Wisconsin'},
  {name:'Cameron Boozer (Duke)', value:'Cameron Boozer', team:'Duke'},
  {name:'Kylan Boswell (Illinois)', value:'Kylan Boswell', team:'Illinois'},
  {name:'Nicholas Boyd (Wisconsin)', value:'Nicholas Boyd', team:'Wisconsin'},
  {name:'Jaden Bradley (Arizona)', value:'Jaden Bradley', team:'Arizona'},
  {name:'Trevon Brazile (Arkansas)', value:'Trevon Brazile', team:'Arkansas'},
  {name:'Maliq Brown (Duke)', value:'Maliq Brown', team:'Duke'},
  {name:'Mikel Brown III (Louisville)', value:'Mikel Brown III', team:'Louisville'},
  {name:'Brayden Burries (Arizona)', value:'Brayden Burries', team:'Arizona'},
  {name:'Elliot Cadeau (Michigan)', value:'Elliot Cadeau', team:'Michigan'},
  {name:'Cameron Carr (Baylor)', value:'Cameron Carr', team:'Baylor'},
  {name:'Rafael Castro (George Washington)', value:'Rafael Castro', team:'George Washington'},
  {name:'Christopher Cenac Jr. (Houston)', value:'Christopher Cenac Jr.', team:'Houston'},
  {name:'Rueben Chinyelu (Florida)', value:'Rueben Chinyelu', team:'Florida'},
  {name:'Oscar Cluff (Purdue)', value:'Oscar Cluff', team:'Purdue'},
  {name:'Ryan Conwell (Louisville)', value:'Ryan Conwell', team:'Louisville'},
  {name:'Quadir Copeland (NC State)', value:'Quadir Copeland', team:'NC State'},
  {name:'Sergio De Larrea (International)', value:'Sergio De Larrea', team:'International'},
  {name:'AJ Dybantsa (Brigham Young)', value:'AJ Dybantsa', team:'Brigham Young'},
  {name:'Zuby Ejiofor (St. John\'s)', value:'Zuby Ejiofor', team:'St. John\'s'},
  {name:'Isaiah Evans (Duke)', value:'Isaiah Evans', team:'Duke'},
  {name:'Jeremy Fears Jr. (Michigan State)', value:'Jeremy Fears Jr.', team:'Michigan State'},
  {name:'Kingston Flemings (Houston)', value:'Kingston Flemings', team:'Houston'},
  {name:'Ja\'Kobi Gillespie (Tennessee)', value:'Ja\'Kobi Gillespie', team:'Tennessee'},
  {name:'Allen Graves (Santa Clara)', value:'Allen Graves', team:'Santa Clara'},
  {name:'Keyshawn Hall (Auburn)', value:'Keyshawn Hall', team:'Auburn'},
  {name:'Jaden Harris (Wake Forest)', value:'Jaden Harris', team:'Wake Forest'},
  {name:'Bryce Hopkins (St. John\'s)', value:'Bryce Hopkins', team:'St. John\'s'},
  {name:'Graham Ike (Gonzaga)', value:'Graham Ike', team:'Gonzaga'},
  {name:'Joshua Jefferson (Iowa State)', value:'Joshua Jefferson', team:'Iowa State'},
  {name:'Morez Johnson Jr. (Michigan)', value:'Morez Johnson Jr.', team:'Michigan'},
  {name:'Alex Karaban (Connecticut)', value:'Alex Karaban', team:'Connecticut'},
  {name:'Trey Kaufman-Renn (Purdue)', value:'Trey Kaufman-Renn', team:'Purdue'},
  {name:'Jack Kayil ( International)', value:'Jack Kayil', team:' International'},
  {name:'Tobi Lawal (Virginia Tech)', value:'Tobi Lawal', team:'Virginia Tech'},
  {name:'Yaxel Lendeborg (Michigan)', value:'Yaxel Lendeborg', team:'Michigan'},
  {name:'Tamin Lipsey (Iowa State)', value:'Tamin Lipsey', team:'Iowa State'},
  {name:'Karim Lopez ( International)', value:'Karim Lopez', team:' International'},
  {name:'Elijah Mahi (Santa Clara)', value:'Elijah Mahi', team:'Santa Clara'},
  {name:'Aday Mara (Michigan)', value:'Aday Mara', team:'Michigan'},
  {name:'Nick Martinelli (Northwestern)', value:'Nick Martinelli', team:'Northwestern'},
  {name:'Isaac McKneely (Louisville)', value:'Isaac McKneely', team:'Louisville'},
  {name:'Duke Miles (Vanderbilt)', value:'Duke Miles', team:'Vanderbilt'},
  {name:'Baba Miller (Cincinnati)', value:'Baba Miller', team:'Cincinnati'},
  {name:'Dillon Mitchell (St. John\'s)', value:'Dillon Mitchell', team:'St. John\'s'},
  {name:'Milan Momcilovic (Iowa State)', value:'Milan Momcilovic', team:'Iowa State'},
  {name:'Malachi Moreno (Kentucky)', value:'Malachi Moreno', team:'Kentucky'},
  {name:'Izaiyah Nelson (South Florida)', value:'Izaiyah Nelson', team:'South Florida'},
  {name:'Tyler Nickel (Vanderbilt)', value:'Tyler Nickel', team:'Vanderbilt'},
  {name:'Ebuka Okorie (Stanford)', value:'Ebuka Okorie', team:'Stanford'},
  {name:'Felix Okpara (Tennessee)', value:'Felix Okpara', team:'Tennessee'},
  {name:'Ugonna Onyenso (Virginia)', value:'Ugonna Onyenso', team:'Virginia'},
  {name:'Otega Oweh (Kentucky)', value:'Otega Oweh', team:'Kentucky'},
  {name:'Koa Peat (Arizona)', value:'Koa Peat', team:'Arizona'},
  {name:'Darryn Peterson (Kansas)', value:'Darryn Peterson', team:'Kansas'},
  {name:'Labaron Philon (Alabama)', value:'Labaron Philon', team:'Alabama'},
  {name:'Jaron Pierre Jr. (SMU)', value:'Jaron Pierre Jr.', team:'SMU'},
  {name:'Jayden Quaintance (Kentucky)', value:'Jayden Quaintance', team:'Kentucky'},
  {name:'Tarris Reed Jr. (Connecticut)', value:'Tarris Reed Jr.', team:'Connecticut'},
  {name:'Malik Reneau (Miami (FL))', value:'Malik Reneau', team:'Miami (FL)'},
  {name:'Billy Richmond III (Arkansas)', value:'Billy Richmond III', team:'Arkansas'},
  {name:'Richie Saunders (Brigham Young)', value:'Richie Saunders', team:'Brigham Young'},
  {name:'Emanuel Sharp (Houston)', value:'Emanuel Sharp', team:'Houston'},
  {name:'Braden Smith (Purdue)', value:'Braden Smith', team:'Purdue'},
  {name:'Hannes Steinbach (Washington)', value:'Hannes Steinbach', team:'Washington'},
  {name:'Bennett Stirtz (Iowa)', value:'Bennett Stirtz', team:'Iowa'},
  {name:'Andrej Stojakovic (Illinois)', value:'Andrej Stojakovic', team:'Illinois'},
  {name:'Peter Suder (Miami (OH))', value:'Peter Suder', team:'Miami (OH)'},
  {name:'Luigi Suigo ( International)', value:'Luigi Suigo', team:' International'},
  {name:'Dailyn Swain (Texas)', value:'Dailyn Swain', team:'Texas'},
  {name:'Tyler Tanner (Vanderbilt)', value:'Tyler Tanner', team:'Vanderbilt'},
  {name:'Meleek Thomas (Arkansas)', value:'Meleek Thomas', team:'Arkansas'},
  {name:'Bruce Thornton (Ohio State)', value:'Bruce Thornton', team:'Ohio State'},
  {name:'JT Toppin (Texas Tech)', value:'JT Toppin', team:'Texas Tech'},
  {name:'Milos Uzan (Houston)', value:'Milos Uzan', team:'Houston'},
  {name:'Henri Veesaar (North Carolina)', value:'Henri Veesaar', team:'North Carolina'},
  {name:'Keaton Wagler (Illinois)', value:'Keaton Wagler', team:'Illinois'},
  {name:'Darrion Williams (NC State)', value:'Darrion Williams', team:'NC State'},
  {name:'Caleb Wilson (North Carolina)', value:'Caleb Wilson', team:'North Carolina'},
  {name:'Tounde Yessoufou (Baylor)', value:'Tounde Yessoufou', team:'Baylor'}
];

const TEAMS = [
  {name:'International', value:' International'},
  {name:'Alabama', value:'Alabama'},
  {name:'Arizona', value:'Arizona'},
  {name:'Arkansas', value:'Arkansas'},
  {name:'Auburn', value:'Auburn'},
  {name:'Baylor', value:'Baylor'},
  {name:'Brigham Young', value:'Brigham Young'},
  {name:'Cincinnati', value:'Cincinnati'},
  {name:'Connecticut', value:'Connecticut'},
  {name:'Duke', value:'Duke'},
  {name:'Florida', value:'Florida'},
  {name:'George Washington', value:'George Washington'},
  {name:'Gonzaga', value:'Gonzaga'},
  {name:'Houston', value:'Houston'},
  {name:'Illinois', value:'Illinois'},
  {name:'Iowa', value:'Iowa'},
  {name:'Iowa State', value:'Iowa State'},
  {name:'Kansas', value:'Kansas'},
  {name:'Kentucky', value:'Kentucky'},
  {name:'Louisville', value:'Louisville'},
  {name:'Miami (FL)', value:'Miami (FL)'},
  {name:'Miami (OH)', value:'Miami (OH)'},
  {name:'Michigan', value:'Michigan'},
  {name:'Michigan State', value:'Michigan State'},
  {name:'NC State', value:'NC State'},
  {name:'North Carolina', value:'North Carolina'},
  {name:'Northwestern', value:'Northwestern'},
  {name:'Ohio State', value:'Ohio State'},
  {name:'Purdue', value:'Purdue'},
  {name:'Santa Clara', value:'Santa Clara'},
  {name:'SMU', value:'SMU'},
  {name:'South Florida', value:'South Florida'},
  {name:"St. John's", value:"St. John's"},
  {name:'Stanford', value:'Stanford'},
  {name:'Tennessee', value:'Tennessee'},
  {name:'Texas', value:'Texas'},
  {name:'Texas Tech', value:'Texas Tech'},
  {name:'UCLA', value:'UCLA'},
  {name:'Vanderbilt', value:'Vanderbilt'},
  {name:'Virginia', value:'Virginia'},
  {name:'Virginia Tech', value:'Virginia Tech'},
  {name:'Wake Forest', value:'Wake Forest'},
  {name:'Washington', value:'Washington'},
  {name:'Wisconsin', value:'Wisconsin'},
];


const QuickSightTabs = ({sheets, activeSheet, setActiveSheet, dashboard, loading, dropdowns, initialParams, children}) => {

    const [searchParams, setSearchParams] = useSearchParams();
    // const [activeView, setActiveView] = useState();
    // const [activeSheet,setActiveSheet] = useState()
    const { hideHeader } = useContext(AppContext);

    const [playerOpen, setPlayerOpen] = useState(false);
    const [playerDropdownPos, setPlayerDropdownPos] = useState({top: 0, left: 0, width: 0});
    const playerDropdownRef = useRef(null);
    const playerButtonRef = useRef(null);
    const playerPanelRef = useRef(null);
    const [selectedPlayers, setSelectedPlayers] = useState(() => {
      const param = searchParams.get("player") || 'ALL_VALUES';
      return param === 'ALL_VALUES' ? PLAYERS.map(p => p.value) : param === 'NONE' ? [] : param.split(',').filter(Boolean);
    });
    const isAllPlayersSelected = selectedPlayers.length === PLAYERS.length;

    useEffect(() => {
      const param = searchParams.get("player") || 'ALL_VALUES';
      setSelectedPlayers(prev => {
        const prevParam = prev.length === PLAYERS.length ? 'ALL_VALUES' : prev.length === 0 ? 'NONE' : prev.join(',');
        if (prevParam === param) return prev;
        return param === 'ALL_VALUES' ? PLAYERS.map(p => p.value) : param === 'NONE' ? [] : param.split(',').filter(Boolean);
      });
    }, [searchParams]);

    useEffect(() => {
      if (!playerOpen) return;
      const handler = (e) => {
        if (playerDropdownRef.current?.contains(e.target)) return;
        if (playerPanelRef.current?.contains(e.target)) return;
        setPlayerOpen(false);
      };
      const close = (e) => { if (playerPanelRef.current && playerPanelRef.current.contains(e.target)) return; setPlayerOpen(false); };
      const onBlur = () => setPlayerOpen(false);
      document.addEventListener('mousedown', handler);
      window.addEventListener('scroll', close, true);
      window.addEventListener('blur', onBlur);
      return () => {
        document.removeEventListener('mousedown', handler);
        window.removeEventListener('scroll', close, true);
        window.removeEventListener('blur', onBlur);
      };
    }, [playerOpen]);


    // team (all-sentinel: 'ALL_VALUES')
    const [teamOpen, setTeamOpen] = useState(false);
    const [teamDropdownPos, setTeamDropdownPos] = useState({top:0, left:0, width:0});
    const teamDropdownRef = useRef(null);
    const teamButtonRef = useRef(null);
    const teamPanelRef = useRef(null);
    const [selectedTeams, setSelectedTeams] = useState(() => {
      const param = searchParams.get("team") || 'ALL_VALUES';
      return param === 'ALL_VALUES' ? TEAMS.map(t => t.value) : param === 'NONE' ? [] : param.split(',').filter(Boolean);
    });
    const isAllTeamsSelected = selectedTeams.length === TEAMS.length;
    useEffect(() => {
      const param = searchParams.get("team") || 'ALL_VALUES';
      setSelectedTeams(prev => {
        const prevParam = prev.length === TEAMS.length ? 'ALL_VALUES' : prev.length === 0 ? 'NONE' : prev.join(',');
        if (prevParam === param) return prev;
        return param === 'ALL_VALUES' ? TEAMS.map(t => t.value) : param === 'NONE' ? [] : param.split(',').filter(Boolean);
      });
    }, [searchParams]);
    useEffect(() => {
      if (!teamOpen) return;
      const handler = (e) => {
        if (teamDropdownRef.current?.contains(e.target)) return;
        if (teamPanelRef.current?.contains(e.target)) return;
        setTeamOpen(false);
      };
      const close = (e) => { if (teamPanelRef.current && teamPanelRef.current.contains(e.target)) return; setTeamOpen(false); };
      const onBlur = () => setTeamOpen(false);
      document.addEventListener('mousedown', handler);
      window.addEventListener('scroll', close, true);
      window.addEventListener('blur', onBlur);
      return () => {
        document.removeEventListener('mousedown', handler);
        window.removeEventListener('scroll', close, true);
        window.removeEventListener('blur', onBlur);
      };
    }, [teamOpen]);
    // Bidirectional filter: visible players filtered by selected teams, and vice versa
    const visiblePlayers = isAllTeamsSelected
      ? PLAYERS
      : PLAYERS.filter(p => selectedTeams.some(t => t.trim() === p.team?.trim()));

    const visibleTeams = isAllPlayersSelected
      ? TEAMS
      : TEAMS.filter(t => PLAYERS.some(p => selectedPlayers.includes(p.value) && p.team?.trim() === t.value.trim()));

    const isAllVisiblePlayersSelected = visiblePlayers.length > 0 && visiblePlayers.every(p => selectedPlayers.includes(p.value));
    const isAllVisibleTeamsSelected = visibleTeams.length > 0 && visibleTeams.every(t => selectedTeams.includes(t.value));

    const handleTeamChange = (value) => {
      let next;
      if (value === 'ALL_VALUES') {
        next = isAllVisibleTeamsSelected
          ? selectedTeams.filter(v => !visibleTeams.some(t => t.value === v))
          : [...new Set([...selectedTeams, ...visibleTeams.map(t => t.value)])];
      } else {
        next = selectedTeams.includes(value)
          ? selectedTeams.filter(v => v !== value)
          : [...selectedTeams, value];
      }
      setSelectedTeams(next);
      const urlValue = next.length === TEAMS.length ? 'ALL_VALUES' : next.length === 0 ? 'NONE' : next.join(',');
      const nextParams = new URLSearchParams(searchParams);
      nextParams.set("team", urlValue);
      setSearchParams(nextParams);
    };

    const handlePlayerChange = (value) => {
      let next;
      if (value === 'ALL_VALUES') {
        next = isAllVisiblePlayersSelected
          ? selectedPlayers.filter(v => !visiblePlayers.some(p => p.value === v))
          : [...new Set([...selectedPlayers, ...visiblePlayers.map(p => p.value)])];
      } else {
        next = selectedPlayers.includes(value)
          ? selectedPlayers.filter(v => v !== value)
          : [...selectedPlayers, value];
      }
      setSelectedPlayers(next);
      let urlValue;
      if (next.length === PLAYERS.length) urlValue = 'ALL_VALUES';
      else if (next.length === 0) urlValue = 'NONE';
      else urlValue = next.join(',');
      const nextParams = new URLSearchParams(searchParams);
      nextParams.set("player", urlValue);
      setSearchParams(nextParams);
    };

    // const location = useLocation();

    // useEffect(() => {
    //   // console.log(location)
    //     if (tabs?.length >0 && location?.pathname) {
    //         setActiveView(tabs?.filter((y) => y.path === location.pathname)[0]?.view)
    //     }
    // }, [location, tabs])


    useEffect(() => {
        const scrollContainer = document.getElementsByClassName('horizontal-scroll');
        if(scrollContainer?.length > 0) {
            scrollContainer[0].addEventListener('wheel', (e) => {
                e.preventDefault();
                scrollContainer[0].scrollLeft += e.deltaY;
            }, { passive: false });
        }
    }, [])

    useEffect(() => {
      console.log('playerOpen: ', playerOpen);
      
    }, [playerOpen])

    const navRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const updateScrollIndicators = () => {
      const el = navRef.current;
      if (!el) return;
      setCanScrollLeft(el.scrollLeft > 0);
      setCanScrollRight(el.scrollLeft < el.scrollWidth - el.clientWidth - 1);
    };

    useEffect(() => {
      const el = navRef.current;
      if (!el) return;
      updateScrollIndicators();
      el.addEventListener('scroll', updateScrollIndicators);
      window.addEventListener('resize', updateScrollIndicators);
      return () => {
        el.removeEventListener('scroll', updateScrollIndicators);
        window.removeEventListener('resize', updateScrollIndicators);
      };
    }, [loading]);

    const years = Array.from({ length: 26 }, (_, i) => 2026 - i);

  return (
    <div className='w-full flex flex-col '>
      <div className={classNames(hideHeader ? 'top-[0px]' : 'top-[55px]',"block px-6 py-2 border-b sticky  z-10 bg-[#f6f6f6]")}>
        <div className="flex flex-row justify-center relative">
          {!loading && canScrollLeft && (
            <div className="md:hidden absolute left-0 top-0 bottom-0 z-20 pointer-events-none flex items-center">
              <div className="flex items-center h-full pl-1 pr-4 bg-gradient-to-r from-[#f6f6f6] via-[#f6f6f6] to-transparent">
                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
              </div>
            </div>
          )}
          {!loading && canScrollRight && (
            <div className="md:hidden absolute right-0 top-0 bottom-0 z-20 pointer-events-none flex items-center">
              <div className="flex items-center h-full pr-1 pl-4 bg-gradient-to-l from-[#f6f6f6] via-[#f6f6f6] to-transparent">
                <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
              </div>
            </div>
          )}
          {!loading && <nav ref={navRef} className="-mb-px flex flex-4 space-x-4 xs:space-x-8 sm:space-x-8 md:space-x-8 lg:space-x-8 overflow-x-scroll hide-scrollbar horizontal-scroll" aria-label="Tabs">
            
            {sheets?.filter((y) => y.Name === 'Overview')?.length > 0 ? <></> :
            <NavLink
                // key={sheets.SheetId}
                to={hideHeader ? '../?header_hide=true&footer_hide=true' : '../'}
                // onClick={() => setActiveSheet(sheets.SheetId)}
                className={classNames('border-transparent text-[#4E525C] hover:border-gray-300 hover:text-black hover:no-underline',
                  'group text-lg inline-flex items-center border-b-2 py-4 px-1 font-medium whitespace-nowrap'
                )}
              >
                <span style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}} >Overview</span>
              </NavLink>
            }


            
            {sheets?.filter((y) => y.Name === '2026 Insights By Sportradar')?.length > 0 ? <></> : sheets.map((sheets) => (
              <button
                key={sheets.SheetId}
                onClick={() => setActiveSheet(sheets.SheetId)}
                className={classNames(
                  sheets.SheetId === activeSheet
                    ? 'border-[#FBCD44] text-black'
                    : 'border-transparent text-[#4E525C] hover:border-gray-300 hover:text-black',
                  'group text-lg inline-flex items-center border-b-2 py-4 px-1 font-medium whitespace-nowrap'
                )}
                aria-current={(e) => sheets.SheetId === activeSheet ? 'page' : undefined}
              >
                <span style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}} >{sheets.Name}</span>
              </button>
            ))}



            {sheets?.filter((y) => y.Name === 'Stat Lab')?.length > 0 ? <></> :
            <NavLink
                // key={sheets.SheetId}
                to={hideHeader ? '../stat-lab?header_hide=true&footer_hide=true' : '../stat-lab'}
                // onClick={() => setActiveSheet(sheets.SheetId)}
                className={classNames('border-transparent text-[#4E525C] hover:border-gray-300 hover:text-black hover:no-underline',
                  'group text-lg inline-flex items-center border-b-2 py-4 px-1 font-medium whitespace-nowrap'
                )}
              >
                <span style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}} >Stat Lab</span>
              </NavLink>
            }

            {sheets?.filter((y) => y.Name === '2026 Insights By Sportradar')?.length > 0 ? <></> :
            <NavLink
                // key={sheets.SheetId}
                to={hideHeader ? '../insights?header_hide=true&footer_hide=true' : '../insights'}
                // onClick={() => setActiveSheet(sheets.SheetId)}
                className={classNames('border-transparent text-[#4E525C] hover:border-gray-300 hover:text-black hover:no-underline',
                  'group text-lg inline-flex items-center border-b-2 py-4 px-1 font-medium whitespace-nowrap'
                )}
              >
                <span style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}} >2026 Insights By Sportradar</span>
              </NavLink>
            }

            {sheets?.filter((y) => y.Name === '2026 Insights By Sportradar')?.length > 0 ? sheets.map((sheets) => (
              <button
                key={sheets.SheetId}
                onClick={() => setActiveSheet(sheets.SheetId)}
                className={classNames(
                  sheets.SheetId === activeSheet
                    ? 'border-[#FBCD44] text-black'
                    : 'border-transparent text-[#4E525C] hover:border-gray-300 hover:text-black',
                  'group text-lg inline-flex items-center border-b-2 py-4 px-1 font-medium whitespace-nowrap'
                )}
                aria-current={(e) => sheets.SheetId === activeSheet ? 'page' : undefined}
              >
                <span style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}} >{sheets.Name}</span>
              </button>
            ))
            : <></>}

            {dropdowns?.includes('year') && <div className=" content-center flex flex-col leading-tight self-end">
              <span className="text-xs text-gray-500 mb-0.5" style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}}>
                  YEAR
                </span>
              <select
                value={initialParams?.length >0 && initialParams?.filter((y) => y?.Name === 'DraftYear2')?.length >0 ? initialParams?.filter((y) => y?.Name === 'DraftYear2')[0]?.Values[0] : '2026'}
                className="w-28 sm:w-36 md:w-36 lg:w-36 pointer bg-white  text-black text-sm sm:text-lg md:text-lg lg:text-lg px-2 py-2 pr-4 border-none focus:border-[#FBCD44] focus:ring-transparent hover:cursor-pointer"
                onChange={(x) => {
                  // console.log(x?.currentTarget?.value); 
                  // setSearchParams({year: x?.currentTarget?.value}); 
                  const next = new URLSearchParams(searchParams);
                  next.set("year", x?.currentTarget?.value);
                  setSearchParams(next);
                  // dashboard?.setParameters([{"Name":"DraftYear2","Values":[x?.currentTarget?.value]}])
                }}
              >
                <option value={'All Records'}>
                    All Records
                  </option>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </select>
            </div>}


             {dropdowns?.includes('position') && <div className="content-center flex flex-col leading-tight self-end">
                <span className="text-xs text-gray-500 mb-0.5" style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}}>
                  POSITION
                </span>
              <select
                value={initialParams?.length >0 && initialParams?.filter((y) => y?.Name === 'PositionSelect')?.length >0 ? initialParams?.filter((y) => y?.Name === 'PositionSelect')[0]?.Values[0] :'All Positions'}
                className="w-32 sm:w-40 md:w-40 lg:w-40 pointer bg-white  text-black text-sm sm:text-lg md:text-lg lg:text-lg px-2 py-2 pr-4 border-none focus:border-[#FBCD44] focus:ring-transparent hover:cursor-pointer"
                onChange={(x) => {
                  const next = new URLSearchParams(searchParams);
                  next.set("position", x?.currentTarget?.value);
                  setSearchParams(next);
                }}
              >
                {[{name:'All Positions', value:'All Positions'},{name:'Forward', value:'Forward'},{name:'Guard', value:'Guard'},{name:'Center', value:'Center'}].map((x) => (
                  <option key={x?.value} value={x?.value}>
                    {x?.name}
                  </option>
                ))}
              </select>
            </div>}

             {dropdowns?.includes('position2') && <div className="content-center flex flex-col leading-tight self-end">
                <span className="text-xs text-gray-500 mb-0.5" style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}}>
                  POSITION
                </span>
              <select
                value={initialParams?.length >0 && initialParams?.filter((y) => y?.Name === 'InsightPosition')?.length >0 ? initialParams?.filter((y) => y?.Name === 'InsightPosition')[0]?.Values[0] :'ALL_VALUES'}
                className="w-32 sm:w-40 md:w-40 lg:w-40 pointer bg-white  text-black text-sm sm:text-lg md:text-lg lg:text-lg px-2 py-2 pr-4 border-none focus:border-[#FBCD44] focus:ring-transparent hover:cursor-pointer"
                onChange={(x) => {
                  const next = new URLSearchParams(searchParams);
                  next.set("position", x?.currentTarget?.value);
                  setSearchParams(next);
                }}
              >
                {[{name:'All Positions', value:'ALL_VALUES'},{name:'Forward', value:'Forward'},{name:'Guard', value:'Guard'},{name:'Center', value:'Center'}].map((x) => (
                  <option key={x?.value} value={x?.value}>
                    {x?.name}
                  </option>
                ))}
              </select>
            </div>}

              {dropdowns?.includes('team') && (
              <div className="content-center flex flex-col leading-tight self-end" ref={teamDropdownRef}>
                <span className="text-xs text-gray-500 mb-0.5" style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}}>LAST PLAYED</span>
                <div className="relative">
                  <button
                    ref={teamButtonRef}
                    type="button"
                    onClick={() => {
                      if (!teamOpen && teamButtonRef.current) {
                        const rect = teamButtonRef.current.getBoundingClientRect();
                        setTeamDropdownPos({top: rect.bottom, left: rect.left, width: rect.width});
                      }
                      setTeamOpen(o => !o);
                    }}
                    className="w-32 sm:w-40 md:w-40 lg:w-40 bg-white text-black text-sm sm:text-lg md:text-lg lg:text-lg px-2 py-2 border-none hover:cursor-pointer flex items-center justify-between"
                  >
                    <span className="truncate">{isAllTeamsSelected ? 'All Teams' : selectedTeams.length === 0 ? 'No Teams' : selectedTeams.length === 1 ? selectedTeams[0] : `${selectedTeams.length} Teams`}</span>
                    <svg className={`w-4 h-4 ml-2 flex-shrink-0 transition-transform ${teamOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
                  </button>
                  {teamOpen && (
                    <div ref={teamPanelRef} style={{position:'fixed', top: teamDropdownPos.top, left: teamDropdownPos.left, width: teamDropdownPos.width, zIndex: 9999}} className="bg-white shadow-lg border border-gray-200 max-h-64 overflow-y-auto">
                      <label className="flex items-center px-3 py-2 hover:bg-gray-50 cursor-pointer border-b border-gray-100">
                        <input type="checkbox" checked={isAllVisibleTeamsSelected} onChange={() => handleTeamChange('ALL_VALUES')} className="mr-2 accent-[#FBCD44]" />
                        <span className="text-sm font-medium">{isAllVisibleTeamsSelected ? 'Deselect All' : 'All Teams'}</span>
                      </label>
                      {visibleTeams.map(t => (
                        <label key={t.value} className="flex items-center px-3 py-1.5 hover:bg-gray-50 cursor-pointer">
                          <input type="checkbox" checked={selectedTeams.includes(t.value)} onChange={() => handleTeamChange(t.value)} className="mr-2 accent-[#FBCD44]" />
                          <span className="text-sm">{t.name}</span>
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}

             {dropdowns?.includes('player') && (
              <div className="content-center flex flex-col leading-tight self-end" ref={playerDropdownRef}>
                <span className="text-xs text-gray-500 mb-0.5" style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}}>
                  Player
                </span>
                <div className="relative">
                  <button
                    ref={playerButtonRef}
                    type="button"
                    onClick={() => {
                      if (!playerOpen && playerButtonRef.current) {
                        const rect = playerButtonRef.current.getBoundingClientRect();
                        setPlayerDropdownPos({top: rect.bottom, left: rect.left, width: rect.width});
                      }
                      setPlayerOpen(o => !o);
                    }}
                    className="w-44 sm:w-56 md:w-56 lg:w-56 bg-white text-black text-sm sm:text-lg md:text-lg lg:text-lg px-2 py-2 border-none hover:cursor-pointer flex items-center justify-between"
                  >
                    <span className="truncate">
                      {isAllPlayersSelected
                        ? 'All Players'
                        : selectedPlayers.length === 0
                          ? 'No Players'
                          : selectedPlayers.length === 1
                            ? PLAYERS.find(p => p.value === selectedPlayers[0])?.name || selectedPlayers[0]
                            : `${selectedPlayers.length} Players`}
                    </span>
                    <svg className={`w-4 h-4 ml-2 flex-shrink-0 transition-transform ${playerOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  {playerOpen && (
                    <div ref={playerPanelRef} style={{position: 'fixed', top: playerDropdownPos.top, left: playerDropdownPos.left, width: playerDropdownPos.width, zIndex: 9999}} className="bg-white shadow-lg border border-gray-200 max-h-64 overflow-y-auto">
                      <label className="flex items-center px-3 py-2 hover:bg-gray-50 cursor-pointer border-b border-gray-100">
                        <input
                          type="checkbox"
                          checked={isAllVisiblePlayersSelected}
                          onChange={() => handlePlayerChange('ALL_VALUES')}
                          className="mr-2 accent-[#FBCD44]"
                        />
                        <span className="text-sm font-medium">
                          {isAllVisiblePlayersSelected ? 'Deselect All' : 'All Players'}
                        </span>
                      </label>
                      {visiblePlayers.map((p) => (
                        <label key={p.value} className="flex items-center px-3 py-1.5 hover:bg-gray-50 cursor-pointer">
                          <input
                            type="checkbox"
                            checked={selectedPlayers.includes(p.value)}
                            onChange={() => handlePlayerChange(p.value)}
                            className="mr-2 accent-[#FBCD44]"
                          />
                          <span className="text-sm">{p.name}</span>
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}

             {/* {dropdowns?.includes('statx') && <div className="content-center">
              <select
                value={initialParams?.length >0 && initialParams?.filter((y) => y?.Name === 'DynamicStatA')?.length >0 ? initialParams?.filter((y) => y?.Name === 'DynamicStatA')[0]?.Values[0] :'HEIGHT'}
                className="w-44 sm:w-56 md:w-56 lg:w-56 pointer bg-white  text-black text-sm sm:text-lg md:text-lg lg:text-lg px-2 py-2 pr-4 border-none focus:border-[#FBCD44] focus:ring-transparent"
                onChange={(x) => {
                  const next = new URLSearchParams(searchParams);
                  next.set("x", x?.target?.value);
                  setSearchParams(next);
                  // dashboard?.setParameters([{"Name":"DynamicStatA","Values":[x?.target?.value]}])
                }}
              >
                {[{'name': 'Hand Length', 'value': 'HAND LENGTH'},
                    {'name': 'Hand Width', 'value': 'HAND WIDTH'},
                    {'name': 'Height', 'value': 'HEIGHT'},
                    {'name': 'Lane Agility Time', 'value': 'LANE AGILITY TIME'},
                    {'name': 'Max Vertical Leap', 'value': 'MAX VERTICAL LEAP'},
                    {'name': 'Shuttle Run', 'value': 'SHUTTLE RUN'},
                    {'name': 'Standing Reach', 'value': 'STANDING REACH'},
                    {'name': 'Standing Vertical Leap', 'value': 'STANDING VERTICAL LEAP'},
                    {'name': 'Three Quarter Sprint', 'value': 'THREE QUARTER SPRINT'},
                    {'name': 'Wingspan', 'value': 'WINGSPAN'},
                    ].map((x) => (
                  <option key={`x${x.name}`} value={x.value}>
                    {x.name}
                  </option>
                ))}
              </select>
            </div>} */}

              {dropdowns?.includes('statx') && <div className="content-center flex flex-col leading-tight self-end">
                <span className="text-xs text-gray-500 mb-0.5" style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}}>
                  Y-AXIS
                </span>

                <select
                  value={initialParams?.length > 0 && initialParams?.filter((y) => y?.Name === 'DynamicStatA')?.length > 0
                    ? initialParams?.filter((y) => y?.Name === 'DynamicStatA')[0]?.Values[0]
                    : 'HEIGHT'}
                  className="w-44 sm:w-56 md:w-56 lg:w-56 bg-white text-black text-sm sm:text-lg md:text-lg lg:text-lg px-2 py-2 pr-4 border-none focus:border-[#FBCD44] focus:ring-transparent hover:cursor-pointer"
                  onChange={(x) => {
                    const next = new URLSearchParams(searchParams);
                    next.set("x", x?.target?.value);
                    setSearchParams(next);
                  }}
                >
                  {[
                    { name: 'Hand Length', value: 'HAND LENGTH' },
                    { name: 'Hand Width', value: 'HAND WIDTH' },
                    { name: 'Height', value: 'HEIGHT' },
                    { name: 'Lane Agility Time', value: 'LANE AGILITY TIME' },
                    { name: 'Max Vertical Leap', value: 'MAX VERTICAL LEAP' },
                    { name: 'Shuttle Run', value: 'SHUTTLE RUN' },
                    { name: 'Standing Reach', value: 'STANDING REACH' },
                    { name: 'Standing Vertical Leap', value: 'STANDING VERTICAL LEAP' },
                    { name: 'Three Quarter Sprint', value: 'THREE QUARTER SPRINT' },
                    { name: 'Wingspan', value: 'WINGSPAN' },
                  ].map((x) => (
                    <option key={`x${x.name}`} value={x.value}>
                      {x.name}
                    </option>
                  ))}
                </select>
              </div>}



            {dropdowns?.includes('staty') && <div className="content-center flex flex-col leading-tight self-end">
                <span className="text-xs text-gray-500 mb-0.5" style={{fontFamily: "Knockout Wide", textTransform: "uppercase"}}>
                  X-AXIS
                </span>
              <select
                value={initialParams?.length >0 && initialParams?.filter((y) => y?.Name === 'DynamicStatB')?.length >0 ? initialParams?.filter((y) => y?.Name === 'DynamicStatB')[0]?.Values[0] :'STANDING VERTICAL LEAP'}
                className="w-44 sm:w-56 md:w-56 lg:w-56 pointer bg-white  text-black text-sm sm:text-lg md:text-lg lg:text-lg px-2 py-2 pr-4 border-none focus:border-[#FBCD44] focus:ring-transparent hover:cursor-pointer"
                onChange={(x) => {
                  const next = new URLSearchParams(searchParams);
                  next.set("y", x?.target?.value);
                  setSearchParams(next);
                  // dashboard?.setParameters([{"Name":"DynamicStatB","Values":[x?.target?.value]}])
                }}
              >
                {[{'name': 'Hand Length', 'value': 'HAND LENGTH'},
                    {'name': 'Hand Width', 'value': 'HAND WIDTH'},
                    {'name': 'Height', 'value': 'HEIGHT'},
                    {'name': 'Lane Agility Time', 'value': 'LANE AGILITY TIME'},
                    {'name': 'Max Vertical Leap', 'value': 'MAX VERTICAL LEAP'},
                    {'name': 'Shuttle Run', 'value': 'SHUTTLE RUN'},
                    {'name': 'Standing Reach', 'value': 'STANDING REACH'},
                    {'name': 'Standing Vertical Leap', 'value': 'STANDING VERTICAL LEAP'},
                    {'name': 'Three Quarter Sprint', 'value': 'THREE QUARTER SPRINT'},
                    {'name': 'Wingspan', 'value': 'WINGSPAN'},
                    ].map((x) => (
                  <option key={`y${x.name}`} value={x.value}>
                    {x.name}
                  </option>
                ))}
              </select>
            </div>}


          </nav>}
          {/* <nav className='flex flex-1 justify-end '>
            <button
                onClick={() => {console.log(dashboard); dashboard && dashboard?.toggleBookmarksPane()}}
                className={classNames('border-transparent text-gray-500 hover:border-gray-300 hover:text-primary-700',
                  'group inline-flex items-center border-b-2 py-4 px-1 text-sm font-medium'
                )}
                aria-current={(e) => sheets.SheetId === activeSheet ? 'page' : undefined}
              >
                <BookmarkIcon
                  className={classNames('text-gray-400 group-hover:text-primary-500',
                    '-ml-0.5 mr-2 h-5 w-5'
                  )}
                  aria-hidden="true"
                />
            </button>
            <button
                onClick={() => {console.log(dashboard); dashboard && dashboard?.initiatePrint()}}
                className={classNames('border-transparent text-gray-500 hover:border-gray-300 hover:text-primary-700',
                  'group inline-flex items-center border-b-2 py-4 px-1 text-sm font-medium'
                )}
                aria-current={(e) => sheets.SheetId === activeSheet ? 'page' : undefined}
              >
                <PrinterIcon
                  className={classNames('text-gray-400 group-hover:text-primary-500',
                    '-ml-0.5 mr-2 h-5 w-5'
                  )}
                  aria-hidden="true"
                />
            </button>
          </nav> */}
        </div>
      </div>
      {children}
    </div>
  )
};

export default QuickSightTabs;